import useToastStore, {
    ToastAlert,
} from '../../../../stores/useToastStore/useToastStore'
import { Alert } from '../Alert'

type ToastProps = ToastAlert

export const Toast: React.FC<ToastProps> = ({
    id,
    variant,
    title,
    description,
}) => {
    const removeAlert = useToastStore((state) => state.removeAlert)

    const handleDismiss = () => {
        removeAlert(id)
    }

    return (
        <Alert
            variant={variant}
            title={title}
            description={description}
            dismissable
            onDismissClick={handleDismiss}
        />
    )
}
